import { CalculationType } from '../../../../../@types/enums';
import { siteCalculationState } from '../../../../../services/siteCalculationState';
import { useViewerStore } from '../../../../../store/store';
import { SetModuleGraph } from '../../Three-JS-Viewer/Controllers/ModuleControl';
import { SetShadeFinalResult } from '../../Three-JS-Viewer/Controllers/RefreshShade';

let batchLayoutSiteCalcDepth = 0;

/** Suppress MODULE_GRAPH shade store writes while generating many layout variants in a row. */
export function beginBatchLayoutSiteCalc(): void {
    if (batchLayoutSiteCalcDepth === 0) {
        useViewerStore.setState({ aiBatchLayoutMutating: true } as any);
        siteCalculationState.clearNeedsUpdate(CalculationType.MODULE_GRAPH);
    }
    batchLayoutSiteCalcDepth += 1;
}

async function flushBatchLayoutSiteCalc(sceneViewer: unknown): Promise<void> {
    siteCalculationState.clearNeedsUpdate(CalculationType.MODULE_GRAPH);
    useViewerStore.setState({ aiBatchLayoutMutating: false } as any);
    if (!sceneViewer) return;
    await SetModuleGraph(sceneViewer as any);
    SetShadeFinalResult(sceneViewer as any);
}

/** Flush a single shade summary update after the outermost batch of layout mutations completes. */
export async function endBatchLayoutSiteCalc(sceneViewer: unknown): Promise<void> {
    if (batchLayoutSiteCalcDepth <= 0) return;
    batchLayoutSiteCalcDepth -= 1;
    if (batchLayoutSiteCalcDepth > 0) return;
    await flushBatchLayoutSiteCalc(sceneViewer);
}

/** Always end batch (e.g. pipeline `finally`) even if begin/end pairs were unbalanced. */
export async function forceEndBatchLayoutSiteCalc(sceneViewer: unknown): Promise<void> {
    batchLayoutSiteCalcDepth = 0;
    await flushBatchLayoutSiteCalc(sceneViewer);
}

/**
 * Run one authoritative shade + module-graph pass mid-batch (per layout variant).
 * Batch mode suppresses shade writes; without this flush, removeGrey and metrics read zeros.
 */
export async function flushVariantLayoutSiteCalc(sceneViewer: unknown): Promise<void> {
    siteCalculationState.clearNeedsUpdate(CalculationType.MODULE_GRAPH);
    useViewerStore.setState({ aiBatchLayoutMutating: false } as any);
    if (!sceneViewer) return;
    await SetModuleGraph(sceneViewer as any);
    SetShadeFinalResult(sceneViewer as any);
    useViewerStore.setState({ aiBatchLayoutMutating: true } as any);
}
